import { DomainLayout } from "@/components/layouts/DomainLayout";
import { TagsView } from "../views/TagsView";

export const TagsPage = () => {
  return (
    <DomainLayout>
      <TagsView />
    </DomainLayout>
  );
};
